module.exports = __webpack_public_path__ + "static/img/login@main-bg.9906688f.png";